import { getManufacturerDashboardInitialFilters, setManufacturerDashboardFilters, useManufacturerDashboardFilters } from "modules/ManufacturerDashboard/hooks";
import { MANUFACTURER_STORAGE_KEYS } from "modules/ManufacturerDashboard/storageKeys";
import { PAGE_SIZE, setPreference } from "utils/common";

import type { OnChangeFn, PaginationState } from "@tanstack/react-table";
import type { DealersLocationsDropdownValue } from "components";

export const useManufacturerFilterHandlers = () => {
  const filters = useManufacturerDashboardFilters();

  const updatePinDropdownOptions = (selectedValues: string[]) => {
    if (selectedValues.at(0) === "all") selectedValues.shift();
    const selectedValueFormatted = selectedValues.includes("all") ? [] : selectedValues.map(value => Number(value));

    setPreference(MANUFACTURER_STORAGE_KEYS.PinTypePreference, selectedValueFormatted);
    setManufacturerDashboardFilters({ ...filters, pin_type_id: selectedValueFormatted, page: 1 });
  };

  const onPageChange = (data: { activePage: number }) => setManufacturerDashboardFilters({ ...filters, page: data.activePage });

  const handlePaginationSelect: OnChangeFn<PaginationState> = updater => {
    const isUpdaterFunction = typeof updater === "function";
    const newState = isUpdaterFunction ? updater({ pageIndex: filters.page - 1, pageSize: filters.page_size }) : updater;
    onPageChange({ activePage: newState.pageIndex + 1 });
  };

  const handleDealerLocationChange = ({ dealerIds, locationIds }: DealersLocationsDropdownValue) => {
    setPreference(MANUFACTURER_STORAGE_KEYS.DealerPreference, dealerIds);
    setPreference(MANUFACTURER_STORAGE_KEYS.LocationPreference, locationIds);
    setManufacturerDashboardFilters({ ...filters, dealer_ids: dealerIds, location_ids: locationIds, page: 1 });
  };

  const handlePageSizeChange = (value: PAGE_SIZE) => {
    setPreference(MANUFACTURER_STORAGE_KEYS.PageSizePreference, value);
    setManufacturerDashboardFilters({ ...filters, page_size: value, page: 1 });
  };

  const handleResetFilters = () => {
    setPreference(MANUFACTURER_STORAGE_KEYS.LocationPreference, []);
    setPreference(MANUFACTURER_STORAGE_KEYS.DealerPreference, []);
    setPreference(MANUFACTURER_STORAGE_KEYS.MechanicFixedPreference, null);
    setPreference(MANUFACTURER_STORAGE_KEYS.PinStatusPreference, null);
    setPreference(MANUFACTURER_STORAGE_KEYS.PinTypePreference, []);
    setPreference(MANUFACTURER_STORAGE_KEYS.RequestStatusPreference, null);
    setPreference(MANUFACTURER_STORAGE_KEYS.WarrantyPreference, null);
    setPreference(MANUFACTURER_STORAGE_KEYS.QuestionStatusPreference, null);
    setPreference(MANUFACTURER_STORAGE_KEYS.PageSizePreference, PAGE_SIZE.PageSize25);

    setManufacturerDashboardFilters(getManufacturerDashboardInitialFilters());
  };

  return { handleDealerLocationChange, updatePinDropdownOptions, handlePaginationSelect, handlePageSizeChange, handleResetFilters };
};
